import { useAtom } from 'jotai';
import { uniqBy } from 'lodash';
import { useMemo } from 'react';

import SearchBar, {
  addZeroCountOptions,
  getSearchableSelectOptions
} from '@/features/SearchBar';
import { RULES_SEARCHABLE_FILTERS } from '@/pages/Administration/AdministrationRules/AdministrationRules.constants';
import {
  filteredRulesAtom,
  rulesAtom,
  rulesFiltersAtom
} from '@/pages/Administration/AdministrationRules/AdministrationRules.store';

const RulesSearch = () => {
  const [rules] = useAtom(rulesAtom);
  const [filteredRules] = useAtom(filteredRulesAtom);
  const [rulesFilters, setRulesFilters] = useAtom(rulesFiltersAtom);

  const rulesSearchableFilters = useMemo(() => {
    const searchableSelectFilters = RULES_SEARCHABLE_FILTERS.map((f) => {
      const filter = { ...f };
      let filterOptions = getSearchableSelectOptions(
        rules,
        filter.field,
        filter.title,
        filter.filterOptions
      );

      // merge the default filter options with the calculated options
      filterOptions = uniqBy(
        [...filterOptions, ...filter.filterOptions],
        'value'
      );

      // if options are defined in the constants, ensure the sort order is maintained
      if (filter.filterOptions.length > 0) {
        const sortingValues = filter.filterOptions.map(
          (option) => option.value
        );

        filterOptions = filterOptions.sort((a, b) =>
          sortingValues.indexOf(a.value) > sortingValues.indexOf(b.value)
            ? 1
            : -1
        );
      }

      if (rulesFilters?.[filter.field]) {
        const updatedFilters = addZeroCountOptions(
          filter,
          rulesFilters,
          filterOptions
        );
        filterOptions = updatedFilters;
      }

      return {
        ...filter,
        filterOptions
      };
    });

    return searchableSelectFilters;
  }, [filteredRules]);

  return (
    <SearchBar
      onFilterChange={setRulesFilters}
      searchableSelectFilters={rulesSearchableFilters}
      selectedFilters={rulesFilters}
    />
  );
};

export default RulesSearch;
